(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["everise-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function readField(form, fieldName) {
      return form.querySelector(`[data-contact-field="${fieldName}"]`)?.value?.trim() || '';
    }

    function setError(root, name, visible) {
      const error = root.querySelector(`[data-contact-error="${name}"]`);
      if (error) error.hidden = !visible;
    }

    function initContactSection(root) {
      const form = root.querySelector('[data-contact-form]');
      const submitButton = root.querySelector('[data-contact-submit]');
      const success = root.querySelector('[data-contact-success]');
      const generalError = root.querySelector('[data-contact-general-error]');
      const webhookUrl = root.dataset.webhookUrl;

      if (!form || !submitButton || !webhookUrl) return;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        success.hidden = true;
        generalError.hidden = true;

        const name = readField(form, 'name');
        const email = readField(form, 'email');
        const phone = readField(form, 'phone');
        const topic = readField(form, 'topic');
        const rawMessage = readField(form, 'message');

        const errors = {
          name: name.length === 0,
          email: !emailPattern.test(email),
          message: rawMessage.length === 0,
        };

        Object.entries(errors).forEach(([field, hasError]) => setError(root, field, hasError));
        if (Object.values(errors).some(Boolean)) return;

        const message = [`Topic: ${topic}`, rawMessage].filter(Boolean).join('\n\n');
        const payload = {
          source: 'shopify_contact_page',
          name,
          email,
          phone,
          topic,
          message,
          pageUrl: window.location.href,
          pageTitle: document.title,
        };

        const originalText = submitButton.textContent;
        submitButton.disabled = true;
        submitButton.textContent = 'Sending...';

        try {
          const response = await fetch(webhookUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: JSON.stringify(payload),
          });

          if (!response.ok) throw new Error('Contact webhook failed');

          form.reset();
          success.hidden = false;
        } catch (error) {
          generalError.hidden = false;
        } finally {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        }
      });
    }

    document.querySelectorAll('[data-everise-contact]').forEach(initContactSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
